import styles from '../../../pages/Kiosk/KioskEdit/KioskEdit.module.css'

const EditField = ({
    attendeeData,
    option,
    states,
    countries,
    handleChange,
}) => {

    //console.log("field name: ", option.cssFieldName)
    //console.log("attendeeData: ", attendeeData)

    function getMatchingValue() {
        if (typeof attendeeData !== 'object' || attendeeData === null) return undefined;

        const cssField = option.cssFieldName.toLowerCase();

        for (const key in attendeeData) {
            //console.log("key name: ", key)
            //console.log("attendeeData: ", attendeeData)

            if (key.toLowerCase() === cssField) {
                //console.log(attendeeData[key])
                return attendeeData[key];
            }
        }

        return undefined; // return undefined if no match found
    }

    return (
        <>
            {
                //option.cssFieldName === 'Country' && countries.some(item => item.countryName === option.fieldValue) ? 
                //    <select
                //        name='country'
                //        value={getMatchingValue()}
                //        onChange={handleChange}
                //        key='country'
                //    >
                //        <option disabled={true} value="" selected="selected">
                //            -- Select an option --
                //        </option>
                //        {
                //            countries.map((ci, idx) => (
                //                <option key={idx}>{ci.countryName}</option>
                //            ))
                //        }
                //    </select>
                //: option.cssFieldName === 'State' && states.some(item => item.stateName === option.fieldValue) ? 
                //    <select
                //        name='state'
                //        value={getMatchingValue()}
                //        onChange={handleChange}
                //        key='state'
                //    >
                //        <option disabled={true} value="" selected="selected">
                //            -- Select an option --
                //        </option>
                //        {
                //            states.map((ci, idx) => (
                //                <option key={idx}>{ci.stateName}</option>
                //            ))
                //        }
                //    </select>
                //        :
                        <input
                        className={styles.fillTable}
                        type="text"
                        autoComplete="off"
                        id={option.fieldLabel}
                            value={getMatchingValue()}
                        name={option.fieldLabel}
                        onChange={handleChange}
                        key={option.fieldLabel}
                    />
            }
        </>        
    );
}

export default EditField;